// extracted by mini-css-extract-plugin
module.exports = {"block":"globalScrolling_block__XC1SO"};